import React, {useEffect, useState} from "react";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Loading from "components/Loading";
import GridBlock from "components/GridBlock";
import BoldTypography from "components/BoldTypography";
import {makeStyles} from "@material-ui/core";
import Form from "components/Form";
import useId from "hooks/useId";
import * as Yup from "yup";
import VS from "constants/ValidationShema";
import DateTimePicker from "components/DateTimePicker";
import TypographyWithIcon from "components/TypographyWithIcon";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import {connect} from "react-redux";
import PartsTable from "components/PartsTable";
import AdditionalRoundPassiveService from "services/AdditionalRoundPassiveService";

const useStyle = makeStyles(theme => ({
    cells: {
        padding: theme.spacing()
    },
    partColumn: {
        width: 75
    },
    dateTimePicker: {
        width: 350
    }
}));


const AdditionalRoundPassiveCreatePopup = (
    {
        demandId,
        onCancel,
        onSuccess,
        formSubmit
    }) => {

    const classes = useStyle();

    const [contractors, setContractors] = useState(null);
    const [working, setWorking] = useState(true);
    const [error, setError] = useState(false);
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    const onSubmit = (values) => {
        setError(false);
        setWorking(true);
        AdditionalRoundPassiveService.createAdditionalPassiveRound(demandId, values).then(onSuccess).catch(() => {
            setError(true);
            setWorking(false);
        })
    }

    useEffect(() => {
        AdditionalRoundPassiveService.getAvailableContractors(demandId).then(resp => setContractors(resp
            .map(x => ({...x, identity: "_" +  x.identity, }))))
            .finally(() => setWorking(false));
    }, [demandId])

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onCancel, 'outlined', working));
        buttons.push(createButton(Tr('additional_round_create_additional_offers_begin_button'), handleSubmit, undefined, working || !contractors?.length));
        return buttons;
    }
    const handleEndDate = (formikProps, value) => {
        formikProps.setFieldValue('openOfferDate', value);
    }

    const validationSchema = () => {
        const shape = {
            contractors: VS.any().test('partSelected', Tr('choose_at_least_two_contractors'), (e) => {
                const selected = Object.keys(e).filter(x => e[x] === true).length;
                return selected > 1;
            }),
            endDate: VS.dateTimeMin(new Date(), Tr('v_time_can_not_be_past')),
            openOfferDate: VS.dateTimeValid()
                .when('endDate', (endDate, schema) => {
                    return schema.test('EndDateLessOpenDate', Tr("EndDateLessOpenDate"), (offerOpenDate) => {
                        if (endDate && offerOpenDate) {
                            return !offerOpenDate.isBefore(endDate);
                        }
                        return false;
                    })
                })
        }
        return Yup.object().shape(shape)
    }

    return (
        <Dialog
            open
            dialogActions={<MultiButton buttons={getButtons()}/>}
            title={Tr('additional_round_create_additional_offers_popup_title')}
            maxWidth='md'
        >
            <GridBlock
                column
            >

                {working && <Loading/>}
                {error && <TypographyWithIcon Icon={ErrorOutlineIcon} color='error'>{Tr('unknown_error_message')}</TypographyWithIcon>}
                {!!contractors && <>

                    <Form
                        initialValues={{
                            endDate: null,
                            openOfferDate: null,
                            contractors: contractors.reduce((prev, cur) => {
                                prev[cur.identity] = false;
                                return prev;
                            }, {})
                        }}
                        validationSchema={validationSchema()}
                        onSubmit={onSubmit}
                        id={formId}
                    >
                        {(formikProps) => (
                            <GridBlock
                                column
                            >
                                <DateTimePicker
                                    className={classes.dateTimePicker}
                                    id='endDate'
                                    label={Tr('additional_round_end_date')}
                                    formikProps={formikProps}
                                    disabled={working || !contractors?.length}
                                    onChange={(value) => handleEndDate(formikProps, value)}
                                    minDate={new Date()}
                                />

                                <DateTimePicker
                                    className={classes.dateTimePicker}
                                    id='openOfferDate'
                                    label={Tr('additional_round_open_offer_date')}
                                    formikProps={formikProps}
                                    disabled={working || !contractors?.length}
                                    minDate={new Date()}
                                />
                                {
                                    !(contractors?.length) ?
                                        <BoldTypography variant='body1'>
                                            {
                                                contractors.error ? contractors.error : Tr('additional_round_auction_list_empty')
                                            }
                                        </BoldTypography>
                                        :
                                        <PartsTable
                                            label={Tr('additional_round_passive_list_title')}
                                            id={'contractors'}
                                            formikProps={formikProps}
                                            elementList={contractors}
                                        />
                                }
                            </GridBlock>
                        )}
                    </Form>


                </>}
            </GridBlock>


        </Dialog>)
}

AdditionalRoundPassiveCreatePopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(AdditionalRoundPassiveCreatePopup)